const store = require('store');

export default class Permissions {
  static getUserRole() {
    return store.get('role');
  }

  static userHasRole(role) {
    return Permissions.getUserRole() === role;
  }

  static isObserver() {
    return Permissions.userHasRole('observer');
  }

  static isFuelShortageUser() {
    return Permissions.userHasRole('fuel_shortage');
  }

  static isEditor() {
    return Permissions.userHasRole('editor');
  }

  static isAdmin() {
    return Permissions.userHasRole('administrator');
  }

  // Returns an array containing the names of permissions for this user, eg: ['perm1', 'perm4']
  static getUserPermissions() {
    const permissions = store.get('permissions');
    if (!permissions) {
      return null;
    }
    return permissions.reduce((agg, cur) => {
      if (cur.value === true) {
        agg.push(cur.name);
      }
      return agg;
    }, []);
  }

  static canEditStationInfo() {
    return Permissions.isAdmin() || Permissions.isEditor();
  }

  static canEditStationFuelTypes() {
    return Permissions.isAdmin() || Permissions.isEditor() || Permissions.isFuelShortageUser();
  }

  static canEditStationFuelPrices() {
    if (Permissions.isAdmin() || Permissions.isEditor()) {
      return true;
    }
    if (Permissions.isObserver()) {
      return !!Permissions.getUserPermissions().find(p => p === 'can_edit_gas_prices');
    }
    return false;
  }

  static canEditStationAmenities() {
    return Permissions.isAdmin() || Permissions.isEditor() || Permissions.isFuelShortageUser();
  }

  static canReplyReview() {
    return Permissions.isAdmin() || Permissions.isEditor();
  }

  static canReplyWithFreeFormText() {
    if (Permissions.isAdmin()) {
      return true;
    }
    if (Permissions.isEditor()) {
      return !!Permissions.getUserPermissions().find(p => p === 'review_reply_free_form_text');
    }
    return false;
  }

  static canExportPDF() {
    return Permissions.isAdmin() || Permissions.isEditor();
  }

  static canSharePage() {
    return Permissions.canExportPDF() || Permissions.isObserver();
  }
}
